import React, { useState } from "react";
import {Button, useMantineTheme} from "@mantine/core";
import {themeProvider} from "../../../../../style/utils";   
import AceEditor from "react-ace";
import "ace-builds/src-min-noconflict/ext-language_tools";
import "ace-builds/src-min-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-monokai";
import "./ScriptEditor.css";
import { StringUtils } from "../../../../../../utils/stringUtils";
import {ScriptEditorProps} from "../../../../../../types/types";

const ScriptEditor = (props: ScriptEditorProps) => {
    const currentTheme = useMantineTheme();
    const [script, setScript] = useState<string>(props.value);
    const jsCode = StringUtils.removeComments(props.value);
    const onChangeScript = (event: any) => {
        setScript(event);
    };

    const onSaveScript = () => {
        const updatedScript = StringUtils.removeComments(script);
        props.setKpiState(kpiState => ({
            ...kpiState,
            kpiInfo: {...kpiState.kpiInfo, statusEvaluator: updatedScript},
            validationErrors: []
        }));
        props.setScript("");
        props && props.setOpened(false);
    };

    const openScriptExecutorDisplay = ()=>{
        props.setScript(StringUtils.removeComments(script));
        props.setScriptEditorOpened(false);
        props.setScriptExecutorOpened(true);
    }

    return (
        <div>
            <div className="scriptEditor-heading"> Script Editor </div>
            <div className="scriptEditor-container">
                <AceEditor
                    className="scriptEditor-editor"
                    aria-label="editor"
                    mode="javascript"
                    theme={currentTheme.colorScheme === 'light' ? "github" : "solarized_dark"}
                    wrapEnabled={true}
                    name="editor"
                    fontSize={16}
                    minLines={19}
                    maxLines={19}
                    width="100%"
                    height="100%"
                    showPrintMargin={false}
                    editorProps={{$blockScrolling: true}}
                    setOptions={{
                        enableBasicAutocompletion: true,
                        enableLiveAutocompletion: true,
                        enableSnippets: true,
                    }}
                    value={StringUtils.removeComments(script)===jsCode ? jsCode : script}
                    onChange={onChangeScript}
                />
                <div className="scriptEditor-buttonContainer">
                    <Button sx={themeProvider} color="teal" variant="outline" style={{marginRight: "70px"}}
                            onClick={onSaveScript}>
                        Submit
                    </Button>
                    <Button sx={themeProvider} color="teal" variant="outline"
                            onClick={openScriptExecutorDisplay}>
                        Test Script
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ScriptEditor;
